import React from 'react'
import { put, select } from 'redux-saga/effects'
import * as modalActions from 'actions/modalActions'
import StandardModalContent from 'GeneralUI/StandardModalContent/StandardModalContent.jsx'
import { xtractAPI } from 'actions/apiActions'
import { clearNotification } from 'actions/notificationActions'
import InsecurePasswordModal from 'components/Auth/UserAlertModals/InsecurePasswordModal.jsx'
import PasswordExpiringSoonModal from 'components/Auth/UserAlertModals/PasswordExpiringSoonModal.jsx'
import TwoFactorSetupRequiredModal from 'components/Auth/UserAlertModals/TwoFactorSetupRequiredModal.jsx'

export function* handleUserAlerts() {
  const notifications = yield select(
    state => state.user.notification_metadata?.urgent_notifications || []
  )
  const modals = yield select(state => state.modal)

  const modalNotifications = notifications.filter(
    notification => notification.type === 'modal'
  )
  if (modalNotifications.length > 0 && modals.length === 0) {
    yield handleModalNotification(modalNotifications[0])
  }
}

function* handleModalNotification(notification) {
  switch (notification.subject) {
    case 'Insecure Password Detected':
      yield handlePwnedCheck(notification)
      break
    case 'Password Expiring Soon':
      yield handlePasswordExpiringSoon(notification)
      break
    case 'Two factor Setup Required':
      yield handleTwoFactorSetupRequired(notification)
      break
    default:
      yield handleGenericNotification(notification)
  }
}

function* handleGenericNotification(notification) {
  yield put(
    modalActions.openModal(notification.subject.replace(' ', '_'), {
      title: notification.subject,
      content: (
        <StandardModalContent
          htmlContent={notification.body}
          okHandler={(trash, dispatch) => {
            dispatch(clearNotification(notification))
            dispatch(
              xtractAPI(
                `me/notification/${notification.notification_id}`,
                'delete',
                {
                  notification_id: notification.notification_id,
                  read_at: true
                },
                {
                  200: () =>
                    dispatch(
                      modalActions.closeModal(
                        notification.subject.replace(' ', '_')
                      )
                    ),
                  404: () =>
                    dispatch(
                      modalActions.closeModal(
                        notification.subject.replace(' ', '_')
                      )
                    ) //if its not there anymore we dont need to worry about deleting it
                }
              )
            )
          }}
          okText={'Ok'}
          okClassName={'btn-danger'}
        />
      ),
      closeable: false
    })
  )
}

function* handleTwoFactorSetupRequired(notification) {
  yield put(
    modalActions.openModal(notification.subject.replace(' ', '_'), {
      title: notification.subject,
      content: <TwoFactorSetupRequiredModal notification={notification} />,
      closeable: false
    })
  )
}

function* handlePwnedCheck(notification) {
  yield put(
    modalActions.openModal(notification.subject.replace(' ', '_'), {
      title: notification.subject,
      content: <InsecurePasswordModal notification={notification} />,
      closeable: false
    })
  )
}

function* handlePasswordExpiringSoon(notification) {
  yield put(
    modalActions.openModal(notification.subject.replace(' ', '_'), {
      title: notification.subject,
      content: <PasswordExpiringSoonModal notification={notification} />,
      closeable: false
    })
  )
}
